import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useParams } from 'react-router-dom';
import { api } from '../api';

const PageWrapper = styled.div`
  min-height: 100vh;
  background: linear-gradient(135deg, #eef2ff 0%, #e0f2fe 100%);
  padding: 2rem 1rem;
`;

const Container = styled.div`
  max-width: 800px;
  margin: 0 auto;
`;

const Title = styled.h1`
  font-size: 2rem;
  font-weight: 800;
  color: #111827;
  margin-bottom: 0.75rem;
`;

const Meta = styled.div`
  font-size: 0.85rem;
  color: #9ca3af;
  margin-bottom: 1.5rem;
`;

const Content = styled.div`
  font-size: 1rem;
  line-height: 1.8;
  color: #374151;
  white-space: pre-wrap;
  background: #ffffff;
  padding: 1.75rem;
  border-radius: 16px;
  box-shadow: 0 10px 25px rgba(15, 23, 42, 0.06);
`;

const TagRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.4rem;
  margin-top: 1rem;
`;

const Tag = styled.span`
  font-size: 0.75rem;
  padding: 0.15rem 0.6rem;
  border-radius: 999px;
  background: #eef2ff;
  color: #4f46e5;
  font-weight: 500;
`;

const BlogPost = () => {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    const load = async () => {
      try {
        const { data } = await api.get(`/api/blog/posts/${slug}`);
        setPost(data.post);
      } catch (e) {
        setError('Yazı bulunamadı veya yüklenirken bir hata oluştu.');
      }
    };
    if (slug) load();
  }, [slug]);

  if (error) {
    return (
      <PageWrapper>
        <Container>
          <p>{error}</p>
        </Container>
      </PageWrapper>
    );
  }

  if (!post) {
    return (
      <PageWrapper>
        <Container>
          <p>Yükleniyor...</p>
        </Container>
      </PageWrapper>
    );
  }

  const date = (post.published_at
    ? new Date(post.published_at)
    : new Date(post.created_at)
  ).toLocaleDateString('tr-TR');

  return (
    <PageWrapper>
      <Container>
        <Title>{post.title}</Title>
        <Meta>{date}</Meta>
        <Content>
          {post.content}
          <TagRow>
            {(post.tags || []).map((tag) => (
              <Tag key={tag}>{tag}</Tag>
            ))}
          </TagRow>
        </Content>
      </Container>
    </PageWrapper>
  );
};

export default BlogPost;

